"use strict";

require("core-js/modules/es6.object.define-property");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _SystemIcons = require("../SystemIcons");

var _core = require("@emotion/core");

var SvgUploadCloud = function SvgUploadCloud(props) {
  return (0, _core.jsx)(_SystemIcons.SystemIcons, props, (0, _core.jsx)("path", {
    d: "M25.085 23.004l.032.003.031.004a1.003 1.003 0 01.081.015l.03.008a.998.998 0 01.229.093l.023.013a.992.992 0 01.11.076l.004.004.082.073 4 4a1 1 0 01-.53 1.691l-.118.014h-.118a.996.996 0 01-.648-.29L26 26.413V33a1 1 0 01-2 0v-6.586l-2.293 2.293a.995.995 0 01-.53.277l-.118.014h-.118a1 1 0 01-.648-1.705l4-4 .082-.073a.994.994 0 01.003-.003l-.085.076a1.007 1.007 0 01.17-.137l.013-.008a.992.992 0 01.013-.008l.023-.013a.997.997 0 01.15-.069l.019-.006a.998.998 0 01.09-.026l.025-.005A1.003 1.003 0 0125 23h.033l.026.002.026.002zm-2.07-8.943A9 9 0 0130.48 20h.522a6 6 0 012.868 11.268 1 1 0 11-.958-1.756A4 4 0 0031 22h-1.26a1 1 0 01-.968-.75 7 7 0 10-12.023 6.388 1 1 0 11-1.498 1.324 9 9 0 017.765-14.901z",
    id: "upload-cloud_svg__a"
  }));
};

var _default = SvgUploadCloud;
exports["default"] = _default;